// extracted by mini-css-extract-plugin
module.exports = {"paragraph-detail":"styles_paragraph-detail__Zts_F","nr-container":"styles_nr-container__TsRmd","image":"styles_image__s3d31","h3":"styles_h3__faDQ1","h4":"styles_h4__v8iaT"};